import React, { useState, useEffect } from "react";


import { Spinner } from "react-bootstrap";

//Prime
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";

import { useLanguage } from "../../../Language/LanguageContext";
import Drone_Status_Regulator from "../../../Style_Component/Steps/User_Drone_Status";
import AuthServiceV2 from "../../../services/auth.serviceV2";
import Static_modal from "../../user/etc/Static_modal";


export default function RemoteID_List() {
  const [remoteDrone, setRemoteDrone] = useState([]);
  const [showRemoveRemote, setShowRemoveRemote] = useState(false);
  const [selectedItemsB, setSelectedItemsB] = useState([]);
  const { t, changeLanguage, language, fontFamily } = useLanguage()
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(true);

  //modal config
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };

  //mui config
  const renderHeaderRemote = () => {
    return (
      <div className="flex flex-wrap gap-2 justify-content-between align-items-center">
        <h4 className="m-0"> </h4>
        <IconField iconPosition="left">
          <InputText
            style={{ width: "auto" }}
            value={globalFilter}
            onChange={(e) => setGlobalFilter(e.target.value)}
            placeholder="🔍  ค้นหา..."
          />
        </IconField>
      </div>
    );
  };
  const headerRemote = renderHeaderRemote();

  function filtered_Remote(data) {
    console.log(data);
    const filteredData = data.filter(
      (item) =>
        item.remoteid_nickname
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.remoteid_serial_number
          .toLowerCase()
          .split(" ")
          .join("")
          .includes(globalFilter.toLowerCase().split(" ").join("")) ||
        item.remoteid_id === parseInt(globalFilter)
    );
    return filteredData;
  }
  const Body_drone_remote_brand = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          {/* <FaUserAstronaut />  {data.owner} */}
          {/* <br /> */}
          {data.remoteid_serial_number}
        </div>
      </div>
    );
  };
  const Body_remote_connect = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data.drone_id !== null ? (
          <td>
            {data.drone_id}- {data.drone_brand_model}
          </td>
        ) : (
          <td>-</td>
        )}
      </div>
    );
  };
  const Body_cancle_remote = (data) => {
    return (
      <>
        <td
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <div
            onClick={() => {
              // Disconnectremoteid(item)
              setShowRemoveRemote(true);
              setSelectedItemsB([data.remoteid_id]);
            }}
            className="custom-btn btnCancel"
            style={{ fontSize: "16px" }}
          >
            X
          </div>
        </td>
      </>
    );
  };

  const Body_drone_remote_name = (data) => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left" }}>
          {/* <FaUserAstronaut />  {data.owner} */}
          {/* <br /> */}
          {data.remoteid_nickname}
        </div>
      </div>
    );
  };

  //fetch
  async function GetRemoteId_Data() {
    const check2 = AuthServiceV2.getoperatorremote();
    if (check2 != null) {
      check2
        .then((response) => {
          //console.log(response);
          if (response.data.dronedata === "No reomte id registered") {
            setRemoteDrone([]);
          } else {
            setRemoteDrone(response.data.dronedata);
          }
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });
        });
    }
  }
  useEffect(() => {
    const fetch = async () => {
      await GetRemoteId_Data();

    }
    fetch();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);



  //loading
  const RenderLoading = () => {
    return (
      <>
        <h2 className="profile-header">RemoteID ในครอบครอง</h2>
        <div className="user-main">
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {" "}
            <Spinner animation="border" variant="secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      {loading ? <RenderLoading /> :
      <>
       <h2 className="profile-header">RemoteID ในครอบครอง</h2>
      <div className="user-main">
        <DataTable
          value={globalFilter ? filtered_Remote(remoteDrone) : remoteDrone}
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          rows={5}
          rowsPerPageOptions={[5, 10, 20, 30, 40, 50]}
          header={headerRemote}
          emptyMessage="ไม่มีข้อมูล"
          tableStyle={{ minWidth: "50rem" }}
          style={{ fontFamily: "Kanit" }}
        >
          {/* <Column
                    header="หมายเลข Remote ID"
                    body={Body_num_remote}
                    field={`remoteid_id`}
                    sortable
                    filterField="remoteid_id"
                    bodyStyle={{ alignItems: "center", textAlign: "center" }}
                    style={{ width: "12%" }}
                  ></Column> */}
          <Column
            header={t('statusdrone.numberRemote')}
            body={Body_drone_remote_brand}
            field={"remoteid_serial_number"}
            sortable
            filterField="remoteid_serial_number"
            bodyStyle={{ alignItems: "center", textAlign: "center" }}
            style={{ width: "15%" }}
          ></Column>

          <Column
            header={t('statusdrone.nameRemote')}
            body={Body_drone_remote_name}
            field="remoteid_nickname"
            sortable
            filterField="remoteid_nickname"
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "15%" }}
          ></Column>
          <Column
            header={t('statusdrone.connectDrone')}
            body={Body_remote_connect}
            field={`drone_id`}
            sortable
            filterField="drone_id"
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "15%" }}
          ></Column>
          <Column
            header={t('statusdrone.deleteRID')}
            body={Body_cancle_remote}
            // field={`drone_id`}
            // sortable
            // filterField="drone_id"
            bodyStyle={{ textAlign: "center" }}
            style={{ width: "20%" }}
          ></Column>
        </DataTable>
      </div>


            {/* vvvv Modal vvvv */}
      <Static_modal
        modalwaiting={modalToggle.modalwait}
        modalErr={modalToggle.modalErr}
        modalSuccess={modalToggle.modalSuccess}
        modalDenied={modalToggle.modalDenied}
        textBody={textBody}
        getHandle={handleClose_Modal}
      />
      </>
     
}
    </>
  );
};

